import React, { useState, useRef, useEffect } from 'react';
import propTypes from 'prop-types';
import _find from 'lodash/find.js';
import _findIndex from 'lodash/findIndex.js';
import _kebabCase from 'lodash/kebabCase.js';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { ColorPicker } from '_ui-core-js/React/components/ColorPicker.jsx';
import { AtmosphereHeroImages } from './AtmosphereHeroImages.jsx';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../constants/analytics.js';

export function AtmosphereHero(props) {

  const { model, subtitle, copy, link, labels, atmosphere, images, carColors, initColorCode } = props;
  const activeColorObjRef = useRef();
  const isMountedRef = useRef(false);
  const [carFrontView, setCarFrontView] = useState(true);
  const [carImageUrl, setCarImageUrl] = useState(images[1].base);
  const block = 'c-atmosphere-hero';

  const heroImages = [images[0], { base: carImageUrl }, images[2]];

  const getImageIndex = () => ({
    front: _findIndex(activeColorObjRef.current.images, image => image.view === 'front'),
    rear: _findIndex(activeColorObjRef.current.images, image => image.view === 'rear')
  });

  function updateCarColorSelection(activeColor) {
    activeColorObjRef.current = activeColor;
    const imageIndex = getImageIndex();
    const imageObj = activeColor.images[carFrontView ? imageIndex.front : imageIndex.rear];
    if (imageObj) {
      setCarImageUrl(imageObj.image);
    }
  };

  function switchCarView() {
    const imageIndex = getImageIndex();
    const imageObj = activeColorObjRef.current.images[carFrontView ? imageIndex.rear : imageIndex.front];
    if (imageObj) {
      setCarImageUrl(imageObj.image);
      setCarFrontView(prevValue => !prevValue);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
  }, []);

  return (
    <div className={block}>
      <CssAnimation 
      enter={{ name: 'short-slide-up-fade-in', duration: 1 }} 
      triggerEnter={true} >
        <div className={`${block}__content-container`}>
          { subtitle && <div className={`${block}__subtitle h5`}>{ subtitle }</div> }
          <h2 className={`${block}__title`}>
            <span className='headline-var-2'>{ model }  </span>
            <span className='headline-var-2 apply-lbx-theme-text'>{ atmosphere }</span>
          </h2>
        </div>
      </CssAnimation>
      <CssAnimation
      enter={{ name: 'fade-in', duration: 1, delay: `1, hidden` }}
      triggerEnter={true}
      >
        <div className={`${block}__color-picker-container`}>
          {
            labels?.colorPicker &&
              <div className='h5'>{labels.colorPicker}</div>
          }
          <ColorPicker
          colors={carColors}
          metallicColors={true}
          initColorCode={initColorCode}
          onChangeCallback={activeColor => updateCarColorSelection(activeColor)}
          />
          <Button 
          label={carFrontView ? labels?.carRearView || 'VIEW REAR' : labels?.carFrontView || 'VIEW FRONT'}
          type='tertiary' 
          icon='rotate'
          slim={true}
          cssAnimation={!isMountedRef.current} 
          cssAnimationTrigger={true}
          cssAnimationDelay={1.5}
          onClickCallback={switchCarView}
          />
        </div>
      </CssAnimation> 
      <AtmosphereHeroImages images={heroImages} />
      <CssAnimation 
      enter={{ name: 'short-slide-up-fade-in', duration: 1 }} 
      triggerEnter={true} >
        <div className={`${block}__content-container`}>
        { copy && <div className={`${block}__copy`}>{ copy }</div> }
          { link && <Button {...{
            ...link,
            cssAnimation: true,
            gtmComponentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
            gtmComponentName: LBX_GTM_TRACKING_VALUES.componentName.lbxStyleSelector,
            gtmLabel: CORE_GTM_TRACKING_VALUES.label.clickCta
          }}/> }
        </div>
      </CssAnimation>
    </div>
  )
};

AtmosphereHero.propTypes = {
  modelName: propTypes.string,
  subtitle: propTypes.string,
  copy: propTypes.string,
  link: propTypes.object,
  atmosphere: propTypes.string.isRequired,
  images: propTypes.array.isRequired
};